export const normalizeFolderToken = (value = '') => (
  value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
);

/** Carpeta libre de entrega final: cualquier usuario puede subir/eliminar aquí. */
export const isPdfsEntregaPath = (folderPath = '') => {
  const target = folderPath.replace(/\\/g, '/').replace(/^\/+|\/+$/g, '');
  const firstSegment = target.split('/')[0] || '';
  const folderNorm = normalizeFolderToken(firstSegment);
  const folderNormNoIndex = normalizeFolderToken(firstSegment.replace(/^\d+_/, ''));
  return (
    folderNorm === 'pdfsentrega' ||
    folderNormNoIndex === 'pdfsentrega' ||
    folderNorm === 'pdfentrega' ||
    folderNormNoIndex === 'pdfentrega'
  );
};
